import VueI18n from 'vue-i18n'
import Vue from 'vue'
import zh from './zh_cn.json'
import ft from './zh_ft.json'
import en from './en.json'
import es from './es.json'
import th from './th.json'
import jp from './jp.json'
import fr from './fr.json'
import vi from './vi.json'
import kr from './kr.json'
import eu from './eu.json'
import de from './de.json'


Vue.use(VueI18n)

export default new VueI18n({
	locale: localStorage.getItem("language") || 'zh',
	messages: {
		zh,
		ft,
		en,
		es,
		th,
		jp,
		fr,
		vi,
		kr,
		de
	}
})
